var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainpagePartnerIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268.606,
    height: 190.828,
    viewBox: "0 0 268.606 190.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mainpage_partner_icon2",
    transform: "translate(1.295 -1677.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pattern",
    transform: "translate(76.483 1772.84) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121663",
    "data-name": "\\uD328\\uC2A4 121663",
    d: "M39.8,0H61.407l73.53,73.53V95.141ZM95.141,0l39.8,39.8V61.407L73.53,0Zm22.929,0a16.251,16.251,0,0,1,11.926,4.942,16.251,16.251,0,0,1,4.942,11.926V27.672L107.264,0Zm0,134.936H107.264L0,27.672V16.867A16.12,16.12,0,0,1,2.372,8.434L126.5,132.564a16.12,16.12,0,0,1-8.434,2.372Zm-44.54,0L0,61.407V39.8l95.141,95.141H73.53Zm-33.734,0L0,95.141V73.53l61.407,61.407H39.8Zm-22.929,0a16.251,16.251,0,0,1-11.926-4.942A16.251,16.251,0,0,1,0,118.069V107.264l27.672,27.672H16.867ZM16.867,0H27.672L134.936,107.264v10.805a16.12,16.12,0,0,1-2.372,8.434L8.434,2.372A16.12,16.12,0,0,1,16.867,0Z",
    transform: "translate(0 0)",
    fill: "#dbe4ee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pattern-2",
    "data-name": "pattern",
    transform: "translate(-1.295 1772.84) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121663-2",
    "data-name": "\\uD328\\uC2A4 121663",
    d: "M39.8,0H61.407l73.53,73.53V95.141ZM95.141,0l39.8,39.8V61.407L73.53,0Zm22.929,0a16.251,16.251,0,0,1,11.926,4.942,16.251,16.251,0,0,1,4.942,11.926V27.672L107.264,0Zm0,134.936H107.264L0,27.672V16.867A16.12,16.12,0,0,1,2.372,8.434L126.5,132.564a16.12,16.12,0,0,1-8.434,2.372Zm-44.54,0L0,61.407V39.8l95.141,95.141H73.53Zm-33.734,0L0,95.141V73.53l61.407,61.407H39.8Zm-22.929,0a16.251,16.251,0,0,1-11.926-4.942A16.251,16.251,0,0,1,0,118.069V107.264l27.672,27.672H16.867ZM16.867,0H27.672L134.936,107.264v10.805a16.12,16.12,0,0,1-2.372,8.434L8.434,2.372A16.12,16.12,0,0,1,16.867,0Z",
    transform: "translate(0 0)",
    fill: "#f1f3f7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainpagePartnerIcon2);
export default __webpack_public_path__ + "static/media/mainpage_partner_icon2.329318edf29c6ec74efee7b64fd03676.svg";
export { ForwardRef as ReactComponent };